/** `₹25,000` from whole paise, with Indian digit grouping. */
export function rupees(paise) {
    const whole = Math.floor(paise / 100);
    const digits = String(whole);
    const last3 = digits.slice(-3);
    const rest = digits.slice(0, -3);
    const grouped = rest === '' ? last3 : `${rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${last3}`;
    return `₹${grouped}`;
}
const LOCALE_TAG = { en: 'en-IN', mr: 'mr-IN', hi: 'hi-IN' };
/**
 * A date in Asia/Kolkata with the month in full, `19 November 2026`, in the language of the person
 * it is written for (R9: stored in UTC, shown in IST). Never `2026-11-19`.
 */
export function dateIst(iso, lang = 'en') {
    const date = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00+05:30`) : new Date(iso);
    return new Intl.DateTimeFormat(LOCALE_TAG[lang], {
        timeZone: 'Asia/Kolkata',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
}
//# sourceMappingURL=money.js.map